var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M7.5 18.25h8.75a4.75 4.75 0 0 0 .8-9.431 4.665 4.665 0 0 0-4.55-3.604 4.97 4.97 0 0 0-4.942 4.507 4.077 4.077 0 0 0-3.683 4.05 4.07 4.07 0 0 0 4.07 4.07M12.438 16.25v-5.125"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "m10.313 13.25 2.124-2.125 2.126 2.125"
})));
export default SvgUploadCloud;